/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams , useLocation} from "react-router-dom";
import { getBizID, getServices } from "../../libs/todoSlice";
import { useEffect } from "react";
import { getSharedTokenRedux, setSharedTokenRedux } from "../../libs/digitalWorkFlowSlice";
import axios from "axios";
import LoadingComponent from "../../lib/LoadingComponent";
import Swal from "sweetalert2";

const Business = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const services = useSelector(getServices);
  const params = useParams();
  const businessID = useSelector(getBizID);
  const getBusiness = async (type) => {
    try {
      const { data } = await axios({
        method: 'GET',
        url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/businesses/redirect/${type}?biz_id=${businessID}`
      })

      if (data && data.data && data.data.redirect_url) {
        window.open(data.data.redirect_url, '_blank');
        navigate(`/${params.prefix}/home`)
      }
    } catch (response) {
        const { status } = response
        if (status === 401) {
          navigate(`/${params.prefix}`)
        }
        Swal.fire({
            icon: 'error',
            title: 'เกิดข้อผิดพลาด',
        });
    }
  };

  useEffect(() => {
    const query = new URLSearchParams(location.search);
    const type = query.get("type")
    getBusiness(type);
    
  }, [params.prefix, location.search]);

  return <LoadingComponent width={150} height={150} />;
};

export default Business;
